import script from "./fault-logitem-tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault-logitem-tag.vue?vue&type=script&lang=ts&setup=true"

import "./fault-logitem-tag.vue?vue&type=style&index=0&id=8fcd73f2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fcd73f2"]])

export default __exports__